import { BulkFeeIntentRow } from './BulkFeeIntentRow';

import { BulkFeeIntent } from '../data';

interface BulkFeeIntentsLoadedProps {
  bulkFeeIntents: BulkFeeIntent[];
}

export const BulkFeeIntentsLoaded: React.FC<BulkFeeIntentsLoadedProps> = ({ bulkFeeIntents }) => {
  return (
    <>
      {bulkFeeIntents.map(bulkFeeIntent => (
        <BulkFeeIntentRow key={bulkFeeIntent.id} bulkFeeIntent={bulkFeeIntent} />
      ))}
    </>
  );
};
